<template>
  <index-content :breadcrumb-items="breadcrumbItems">
    <template #options>
      <div class="n-button-box">
        <nb-download :url="CSV_URL" :params="condition" />
      </div>
    </template>
    <div class="table-responsive">
      <table class="table table-bordered table-hover table-striped text-center n-table">
        <thead>
          <th class="col-weight-2">{{ $t('label.id') }}</th>
          <th class="col-weight-2">{{ $t('label.company') }}</th>
          <th class="col-weight-3">{{ $t('label.configType') }}</th>
          <th class="col-weight-8">{{ $t('label.configValue') }}</th>
          <th class="n-table-timestamp">{{ $t('label.lastUpdate') }}</th>
          <th v-table-action class="action-edit">{{ $t('label.action') }}</th>
        </thead>
        <tbody>
          <tr v-for="row in records" :key="row.id">
            <td>{{ row.id }}</td>
            <td v-selection:[`company.company`]="row.companyId"></td>
            <td v-enums:CompanyConfigType="row.configType"></td>
            <td v-if="row.secure">********</td>
            <td v-else :title="row.configValue">{{ row.configValue | hyphen }}</td>
            <td>{{ row.updateDatetime | datetime }}</td>
            <td class="n-button-box"><nb-modal :disabled="row.secure || row.readonly" @on-click="openModal(row)"></nb-modal></td>
          </tr>
        </tbody>
      </table>
    </div>
  </index-content>
</template>

<script>
import BaseCompanyView from './view';
import { getSelection } from '@/store';
import ModalCompanyConfig from './ModalCompanyConfig';
import { CSV_URL, fetch } from '@/api/company/company-config';

export default BaseCompanyView.extend({
  name: 'CompanyCompanyConfig',

  data() {
    return {
      CSV_URL,
      preload: true,
      condition: {
        companyId: this.$route.params.companyId,
      },
    };
  },

  mounted() {
    let companyId = +this.$route.params.companyId;
    let companyName = getSelection('company.company', companyId);
    this.breadcrumbItems = [companyName, this.$t(`label.configs`)];
  },

  methods: {
    parse(r) {
      this.records = r;
    },

    openModal(model = {}) {
      this.createModal(ModalCompanyConfig, { model, props: { subName: 'companyConfig' }, on: this });
    },

    doLoad() {
      let companyId = this.condition.companyId;
      return fetch({ companyId });
    },
  },
});
</script>
